import React from 'react';
import pathOr from 'ramda/es/pathOr';

const PromocodeDetails = (props) => {
  const list = pathOr([], ['record', 'bounds'], props);
  return (
    <ul>
      <li className="df aifs">
        <h5>{props.listTitles[0].title}</h5>
        <span className="promocode__bound-wrapper df fww">
          {list.map((item) => {
            const title = item.title;
            const value = pathOr([], ['value'], item);
            return (
              <span className="promocode__bound-item df">
                <span className="promocode__bound-kind">{title}</span>
                <span className="promocode__bound-value">{Array.isArray(value) ? value.join(', ') : value}</span>
              </span>
            );
          })}
        </span>
      </li>
      <li className="df">
        <h5>{props.listTitles[1].title}</h5>
        <span>{props.record.commentary}</span>
      </li>
    </ul>
  );
};

export default PromocodeDetails;
